import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
import Investor from '../../../models/Investor';
import EoiCard from './EoiCard';
import SectionCard from './SectionCard';

export default function ActiveEoiSection({
  activeEoiInvestors,
  investmentsLoading,
  navigate,
}: {
  activeEoiInvestors: Investor[];
  investmentsLoading: boolean;
  navigate: (path: string) => void;
}) {
  return (
    <SectionCard
      title="Active Expressions of Interest"
      icon={<DescriptionOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />}
      loading={investmentsLoading}
    >
      {!investmentsLoading && activeEoiInvestors.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No active expressions of interest.
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {activeEoiInvestors.map((inv) => (
          <EoiCard key={inv.id} investor={inv} navigate={navigate} />
        ))}
      </Box>
    </SectionCard>
  );
}
